"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var http_1 = require("@angular/common/http");
var rxjs_1 = require("rxjs");
var registration_form_provider_1 = require("../../services/registration-form.provider");
var registration_provider_1 = require("../../services/registration.provider");
var currencies_service_1 = require("../../services/currencies.service");
var vc_map_1 = require("../../util/vc-map");
var REDIRECT_DELAY_MS = 2000;
var RegisterComponent = /** @class */ (function () {
    function RegisterComponent(activatedRoute, http, currenciesService, registrationFormProvider, registrationProvider) {
        this.activatedRoute = activatedRoute;
        this.http = http;
        this.currenciesService = currenciesService;
        this.registrationFormProvider = registrationFormProvider;
        this.registrationProvider = registrationProvider;
        this.currentStep = 'step1';
        this.registrationForm = registrationFormProvider.registrationForm;
    }
    RegisterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.prefillFromQueryParams();
        rxjs_1.forkJoin(this.http.get('assets/countries.json'), this.http.get('assets/country2timezone.json'), this.currenciesService.getCurrencies()).subscribe(function (_a) {
            var countries = _a[0], timeZones = _a[1], currencies = _a[2];
            _this.countryList = countries;
            _this.timeZones = timeZones;
            _this.currencies = currencies;
        });
    };
    RegisterComponent.prototype.onNext = function () {
        if (this.registrationFormProvider.isStep1Valid()) {
            this.currentStep = 'step2';
        }
        else {
            this.registrationFormProvider.step1MarkAsTouched();
        }
    };
    RegisterComponent.prototype.onBack = function () {
        this.currentStep = 'step1';
    };
    RegisterComponent.prototype.onSubmitted = function (redirect) {
        var _this = this;
        this.redirectUrl = redirect;
        this.currentStep = 'thankyou';
        setTimeout(function () { return _this.redirectToStore(); }, REDIRECT_DELAY_MS);
    };
    RegisterComponent.prototype.redirectToStore = function () {
        window.location.href = this.redirectUrl;
    };
    RegisterComponent.prototype.prefillFromQueryParams = function () {
        var _this = this;
        var params = vc_map_1.VcMap.fromRouteParamMap(this.activatedRoute.snapshot.queryParamMap);
        if (!params.hasAnyValue()) {
            return;
        }
        params.forEach(function (value, key) {
            if (key === 'country') {
                _this.registrationForm.get('country').setValue(value.toLowerCase());
            }
            else if (_this.registrationForm.get(key)) {
                _this.registrationForm.get(key).setValue(value);
            }
        });
        var name = params.get('extra_data[integration][name]');
        var accessToken = params.get('extra_data[integration][configuration][accessToken]');
        if (name && accessToken) {
            this.registrationProvider.mewsExtraData = {
                integration: { name: name, configuration: { accessToken: accessToken } }
            };
        }
    };
    return RegisterComponent;
}());
exports.RegisterComponent = RegisterComponent;
